<template>
 <div class="container">
   <div class="container__about__hero">
      <img class="container__about__hero__hero-image" src="../assets/casual-cellphones-chatting.jpg" alt="Picture of people texting on their phones" />
      <img class="container__about__hero__mobile-hero-image" src="../assets/mobile2.jpg" alt="Picture of a computer on a table" />
      <p class="container__about__hero__text">
        The psychology
        <br />behind user
        <br />experience
      </p>
      <router-link to="/vision"><button class="btn btn--secondary">Read my vision</button></router-link>
    </div>
    <p class="container__section-headline">About me</p>
    <div class="container__about__main">
      <img class="container__about__main__image" src="../assets/profile.jpg" alt="Pictue of Marc"/>
      <div class="container__about__main__text">
        <h3>
          Hello!<br>
          My name is Marc.<br>
          I am your <span class="container__about__main__text--letter-design">digital</span> handyman.
        </h3>
        <p>
          When I was 6 years old, my father bought me my very first camera. It was the beginning of a life-long passion for visual and digital presentations. I now hold a degree as a Multimedia Designer and is currently studying Web Development. I also spent 6 years of studying marketing and inter-cultural business relations. Understanding the psychology behind the consumer has always been a fascinating topic to me, and it plays a very important role in how conduct my research and how I design my products. Understanding the human mind is the key to a succesful business strategy.
          You can read more about my view on this subject on the section below.
        </p>
      </div>
    </div>
    </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {};
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/main.scss";
</style>


// WEBPACK FOOTER //
// src/components/About.vue